import { composeWhatsOnSections } from './composeWhatsOnSections';

/** Home is a compact projection of the same time/identity/novelty contract. */
export function composeTeaserSections({ feed, ranked = feed || [], ...options } = {}) {
  return composeWhatsOnSections({ ...options, ranked, home: true });
}

export function composeTeaser(options) {
  return composeTeaserSections(options).flatMap(section => section.items);
}

export default composeTeaser;
